import { capitalizeFirstLetter } from 'helpers/formatting';

export default function repTemplate(data) {
  return data.firstName || data.lastName ? `${capitalizeFirstLetter(data.firstName).charAt(0)}. ${data.lastName}` : '';
}
